(() => {
  const DORMANT = 'ted-chat-dormant';

  function hosts() {
    return [
      ...document.querySelectorAll('shopify-chat'),
      ...document.querySelectorAll('#shopify-chat'),
      ...document.querySelectorAll('inbox-online-store-chat'),
    ];
  }

  function setDormant(on) {
    hosts().forEach((host) => {
      host.classList.toggle(DORMANT, on);
      if (on) {
        host.style.setProperty('--shopify-chat-activator-offset', '-9999px');
        host.setAttribute('aria-hidden', 'true');
        host.style.removeProperty('display');
        host.style.removeProperty('visibility');
        host.style.removeProperty('pointer-events');
      } else {
        host.style.removeProperty('--shopify-chat-activator-offset');
        host.removeAttribute('aria-hidden');
        host.style.removeProperty('display');
        host.style.removeProperty('visibility');
        host.style.removeProperty('pointer-events');
      }
    });

    const legacy = document.querySelector('#dummy-chat-button, #dummy-chat-button-iframe');
    if (legacy) {
      legacy.style.setProperty('display', on ? 'none' : '', 'important');
      if (on) legacy.setAttribute('aria-hidden', 'true');
      else legacy.removeAttribute('aria-hidden');
    }
  }

  function injectShadowLauncherHide(host) {
    const root = host.shadowRoot;
    if (!root || root._tedLauncherHidden) return;
    const style = document.createElement('style');
    style.textContent = `
      button.chat-toggle,
      button.activator,
      .activator:not([aria-expanded="true"]),
      [part="button"],
      [part="activator"],
      button[aria-expanded="false"] {
        opacity: 0 !important;
        pointer-events: none !important;
        position: fixed !important;
        right: -9999px !important;
        width: 1px !important;
        height: 1px !important;
        z-index: -1 !important;
      }
    `;
    root.appendChild(style);
    root._tedLauncherHidden = true;
  }

  function hideLaunchers() {
    // Keep native launcher hidden unless we intentionally opened chat
    if (!document.documentElement.hasAttribute('data-ted-chat-open')) {
      setDormant(true);
    }
    hosts().forEach(injectShadowLauncherHide);
  }

  function findLauncher(root) {
    if (!root) return null;
    const buttons = [...root.querySelectorAll('button')];
    return (
      buttons.find((b) => b.classList.contains('chat-toggle')) ||
      buttons.find((b) => b.classList.contains('activator')) ||
      buttons.find((b) => /chat|aide|help/i.test(`${b.textContent || ''} ${b.getAttribute('aria-label') || ''}`)) ||
      buttons.find((b) => b.getAttribute('aria-expanded') != null) ||
      buttons[0] ||
      null
    );
  }

  function openViaApi(host) {
    try {
      if (typeof host.show === 'function') {
        host.show();
        return true;
      }
      if ('open' in host) {
        host.open = true;
        return true;
      }
      if (!host.hasAttribute('open')) {
        host.setAttribute('open', '');
        return true;
      }
    } catch (_) {}
    return false;
  }

  function isHostOpen(host) {
    try {
      if (host.open === true) return true;
    } catch (_) {}
    if (host.hasAttribute('open')) return true;
    const root = host.shadowRoot || host;
    if (root.querySelector('button[aria-expanded="true"]')) return true;
    if (root.querySelector('dialog[open], [role="dialog"][open]')) return true;
    return false;
  }

  function clickOpen() {
    for (const host of hosts()) {
      if (openViaApi(host)) return true;
    }

    for (const host of hosts()) {
      const btn = findLauncher(host.shadowRoot) || findLauncher(host);
      if (btn) {
        btn.click();
        return true;
      }
    }

    try {
      const iframe = document.querySelector('#dummy-chat-button-iframe');
      if (iframe?.contentDocument) {
        const btn = findLauncher(iframe.contentDocument);
        if (btn) {
          btn.click();
          return true;
        }
      }
    } catch (_) {}

    const legacy = document.querySelector('#dummy-chat-button');
    if (legacy) {
      legacy.click();
      return true;
    }

    try {
      const api = window.Inbox || window.ShopifyChat || window.Shopify?.chat;
      if (api && typeof api.open === 'function') {
        api.open();
        return true;
      }
    } catch (_) {}

    return false;
  }

  function watchClose() {
    const check = () => {
      if (!document.documentElement.hasAttribute('data-ted-chat-open')) return;
      let stillOpen = hosts().some(isHostOpen);
      if (!stillOpen) {
        document.documentElement.removeAttribute('data-ted-chat-open');
        setDormant(true);
      }
    };
    setTimeout(check, 400);
    setTimeout(check, 1200);
    setTimeout(check, 3000);
    // Keep watching a bit longer — user may close the panel later
    const interval = setInterval(check, 800);
    setTimeout(() => clearInterval(interval), 120000);
  }

  function openChatWithRetry() {
    if (window.tedSupportPanel) window.tedSupportPanel.setOpen(false);

    document.documentElement.setAttribute('data-ted-chat-open', '1');
    setDormant(false);

    const tryOpen = () => {
      hosts().forEach(injectShadowLauncherHide);
      const opened = clickOpen();
      if (opened || hosts().some(isHostOpen)) return true;
      return false;
    };

    requestAnimationFrame(() => {
      if (tryOpen()) {
        watchClose();
        setTimeout(() => hosts().forEach(injectShadowLauncherHide), 200);
        return;
      }

      let attempts = 0;
      const timer = setInterval(() => {
        if (tryOpen() || ++attempts > 30) {
          clearInterval(timer);
          if (hosts().some(isHostOpen) || attempts <= 30) watchClose();
          setTimeout(() => hosts().forEach(injectShadowLauncherHide), 200);
          if (attempts > 30 && !hosts().some(isHostOpen)) {
            document.documentElement.removeAttribute('data-ted-chat-open');
            setDormant(true);
          }
        }
      }, 200);
    });
  }

  document.querySelectorAll('[data-ted-open-chat]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openChatWithRetry();
    });
  });

  hideLaunchers();
  new MutationObserver(hideLaunchers).observe(document.documentElement, { childList: true, subtree: true });
  [200, 600, 1200, 2500, 5000].forEach((ms) => setTimeout(hideLaunchers, ms));
})();
